import { memo } from 'react';
import './style.scss';

const PageHeader = memo(({ classNames, title, children }) => {
	return (
		<div className={`page-header mb-4 d-flex justify-content-between align-items-center ${classNames ? classNames : ''}`}>
			<p className='page-header-title mb-0'>{title}</p>
			<div className='d-flex gap-1'>{children}</div>
		</div>
	);
});
export default PageHeader;
